import mushroom from "viettoc-api";
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import LanguageService from "../../../service/LanguageService";
import DataForm from "../../../dataForm/dataFormBanIn";
import { Circle4 } from "vue-loading-spinner";
import eventBus from "../../../service/EventBus";
// import { ElMessageBox } from 'element-plus';
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        dataForm: MethodService.copyObject(DataForm.dataForm),
        trangThaiBanIn: MethodService.copyObject(DataForm.trangThai),
        trangThaiInGiaPhaSales_SalesManager: MethodService.copyObject(
          DataForm.trangThaiInGiaPhaSales_SalesManager
        ),
        trangThaiDonHang: MethodService.copyObject(DataForm.donHang),
        theme: MethodService.copyObject(DataForm.theme),
      },
      validForm: {
        trang_thai: [ValidService.required],
        don_hang: {
          da_chot_don: [ValidService.required],
        },
        lien_he: {
          ho_ten: [ValidService.required],
          dien_thoai: [ValidService.required, ValidService.checkPhone],
        },
        nguoi_dung_id: [ValidService.required],
        dong_ho_id: [ValidService.required],
        thong_tin: {
          so_doi: [ValidService.checkNumberFloatNotNegative],
          so_node: [ValidService.checkNumberFloatNotNegative],
        },
        so_luong: [ValidService.checkNumberFloatNotNegative],
      },
      listDongHo: [], // danh sách các dòng họ dùng để thêm mới bản in
      listNguoiTrongHo: [], // danh sách các thành viên trong họ để lấy nguoi_dung_id, user_id, node_id
      dongHoId: "", // id của dòng họ sau khi select
      showChonNguoiDung: false, // chuyển thành true khi chọn được 1 dòng họ
      nguoiDungID: "", // nguoi_dung_id, user_id
      nodeID: "", // node_id
      userID: "", // user_id
      anh_dai_dien_id: "",
      successAnhDaiDien: false,
      successBanIn: false,
      successThietKe: false,
      successWatermark: false,
      // quyền tài khoản đăng nhập
      SalesManagerOrInGiaPhaSales: false,
      CustomerCareUser: false,
      SystemAdmin: false,
      InGiaPhaDesigner: false,
      trangThaiBanIn: "", // trạng thái bản in hiện tại
      trangThaiBanInInput: "", // trạng thái bản in cho ô input
      dongHoName: "", // tên dòng họ
      linkGiaPha: "",
      listNode: [],
      listNodeHide: [],
      dialogThongBao: false,
      nodeTrung: {},
    };
  },

  components: {
    Circle4,
  },

  methods: {
    async fn_initForm() {
      this.listNode = [];
      this.listNodeHide = [];
      try {
        const response = await mushroom.ban_in.findByIdAsync({
          id: this.$router.currentRoute.params.id,
        });
        let resData = await this.fn_changeData(response.result);
        this.mData.dataForm = await resData;
        this.trangThaiBanIn = this.mData.dataForm.trang_thai;
        this.trangThaiBanInInput = this.renderTrangThaiBanIn(
          this.mData.dataForm.trang_thai
        );
        this.loading = false;
        this.linkGiaPha = `https://qr.viettoc.vn/giapha/?pid=${response.result.id}&f=${response.result.dong_ho_id}`;

        const dongHoById = await mushroom.dong_ho.findByIdAsync({
          id: response.result.dong_ho_id,
        });
        this.dongHoName = dongHoById.result.ten;
      } catch (e) {
        console.error("Có lỗi: %o", e);
        this.loading = false;
        MethodService.showError(e.code);
      }
    },

    async fn_getThongTinNguoiChuyenTrangThaiBanIn(id) {
      try {
        const resNguoiDung = await mushroom.nguoi_dung.listAsync(
          {
            filters: ["user_id=" + id],
          },
          { enabledCache: false }
        );
        let hoTen = "";
        if (resNguoiDung && resNguoiDung.result.length > 0) {
          resNguoiDung.result.forEach((item) => {
            if (item.kich_hoat == false) return;
            if (item.ten.xung_ho && item.ten.xung_ho === "ong") {
              hoTen = "Ông " + item.ten.ho_ten;
            }
            if (item.ten.xung_ho && item.ten.xung_ho === "ba") {
              hoTen = "Bà " + item.ten.ho_ten;
            }
            if (item.ten.xung_ho && item.ten.xung_ho === "anh") {
              hoTen = "Anh " + item.ten.ho_ten;
            }
            if (item.ten.xung_ho && item.ten.xung_ho === "chi") {
              hoTen = "Chị " + item.ten.ho_ten;
            }
          });
          return hoTen;
        } else {
          const response = await mushroom.user.findByIdAsync(
            {
              id: id,
            },
            { enabledCache: false }
          );
          hoTen = response.result.account;
          return hoTen;
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async fn_changeData(data) {
      data.thoi_diem_tao = MethodService.formatDate(
        data.thoi_diem_tao,
        "datetime"
      );
      if (data.don_hang) {
        data.don_hang.thoi_diem_chot = MethodService.formatDate(
          data.don_hang.thoi_diem_chot,
          "datetime"
        );
      }

      data.lien_he.dien_thoai = MethodService.changePhone(
        data.lien_he.dien_thoai
      );
      if (data.lich_su) {
        data.lich_su = data.lich_su.reverse();
        data.lich_su[0].color = "#0bbd87";
        data.lich_su[0].icon = "el-icon-check";
        data.lich_su.forEach(async (element) => {
          element.nguoi_chuyen = "";
          element.nguoi_chuyen =
            await this.fn_getThongTinNguoiChuyenTrangThaiBanIn(
              element.nguoi_chuyen_id
            );
          element.thoi_diem = MethodService.formatDate(
            element.thoi_diem,
            "datetime"
          );
          element.trang_thai_sau === "gui_yeu_cau"
            ? (element.trang_thai_sau = "Gửi yêu cầu")
            : element.trang_thai_sau === "dang_tu_van"
            ? (element.trang_thai_sau = "Đang tư vấn")
            : element.trang_thai_sau === "dang_san_xuat"
            ? (element.trang_thai_sau = "Đang sản xuất")
            : element.trang_thai_sau === "dang_giao_hang"
            ? (element.trang_thai_sau = "Đang giao hàng")
            : element.trang_thai_sau === "hoan_thanh"
            ? (element.trang_thai_sau = "Hoàn thành")
            : (element.trang_thai_sau = "Hủy");

          // lấy thông tin người chuyển trạng thái bản in
        });
      }

      if (!data.bao_hanh) {
        data.bao_hanh = {
          bat_dau: null,
          ket_thuc: null,
          thoi_han: null,
        };
      } else {
        data.bao_hanh.bat_dau = MethodService.formatDate(
          data.bao_hanh.bat_dau,
          "year"
        );
        data.bao_hanh.ket_thuc = MethodService.formatDate(
          data.bao_hanh.ket_thuc,
          "year"
        );
      }

      if (!data.thong_tin) {
        data.thong_tin = {
          so_node: undefined,
          so_doi: undefined,
        };
      } else {
        this.soDoi = data.thong_tin.so_doi;
      }

      // if(!data.so_luong) {
      //     data.so_luong = undefined;
      // } else {
      //     data.so_luong = data.so_luong;
      // }

      return data;
    },

    async fn_add() {
      const ban_in_object = {
        dong_ho_id: this.dongHoId,
        user_id: this.userID,
        nguoi_dung_id: this.nguoiDungID,
        node_id: this.nodeID,
        cau_hinh: {
          ten_pha_do: this.mData.dataForm.cau_hinh.ten_pha_do,
          ten_toc: this.mData.dataForm.cau_hinh.ten_toc,
          dia_chi: this.mData.dataForm.cau_hinh.dia_chi,
          in_dau_re: this.mData.dataForm.cau_hinh.in_dau_re,
          in_ngay_sinh: this.mData.dataForm.cau_hinh.in_ngay_sinh,
          in_ngay_gio: this.mData.dataForm.cau_hinh.in_ngay_gio,
          compact_layout_width:
            this.mData.dataForm.cau_hinh.compact_layout_width,
          compact_layout_height:
            this.mData.dataForm.cau_hinh.compact_layout_height,
          theme: this.mData.dataForm.cau_hinh.theme,
        },
        lien_he: {
          ho_ten: this.mData.dataForm.lien_he.ho_ten,
          dien_thoai: this.mData.dataForm.lien_he.dien_thoai,
          dia_chi: this.mData.dataForm.lien_he.dia_chi,
        },
      };
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            const response = await mushroom.ban_in.createAsync(ban_in_object);
            if (response.result) {
              window.toastr.success("Thêm mới Bản in thành công");
              MethodService.stopLadda();
              this.$router.go(-1);
              eventBus.$emit("doiTrangThaiBanIn");
            }
          } catch (e) {
            MethodService.showError(e.code);
          }
        } else MethodService.stopLadda();
      });
    },

    // cập nhật bản in
    async fn_update() {
      const ban_in_object = {
        id: this.$router.currentRoute.params.id,
        cau_hinh: {
          compact_layout_width:
            this.mData.dataForm.cau_hinh.compact_layout_width,
          compact_layout_height:
            this.mData.dataForm.cau_hinh.compact_layout_height,
        },
        so_luong: this.mData.dataForm.so_luong
          ? Number(this.mData.dataForm.so_luong)
          : null,
      };

      if (
        this.mData.dataForm.thong_tin.so_doi &&
        Number(this.mData.dataForm.thong_tin.so_doi) <= 0
      ) {
        return;
      }
      if (
        this.mData.dataForm.thong_tin.so_node &&
        Number(this.mData.dataForm.thong_tin.so_node) <= 0
      ) {
        return;
      }

      if (
        this.CustomerCareUser ||
        (this.SystemAdmin &&
          this.trangThaiBanIn !== "hoan_thanh" &&
          this.trangThaiBanIn !== "huy")
      ) {
        (ban_in_object.bao_hanh = {
          bat_dau: this.mData.dataForm.bao_hanh.bat_dau
            ? new Date(this.mData.dataForm.bao_hanh.bat_dau).toISOString()
            : null,
          ket_thuc: this.mData.dataForm.bao_hanh.ket_thuc
            ? new Date(this.mData.dataForm.bao_hanh.ket_thuc).toISOString()
            : null,
          thoi_han: this.mData.dataForm.bao_hanh.thoi_han,
        }),
          (ban_in_object.thong_tin = {
            so_node: this.mData.dataForm.thong_tin.so_node
              ? Number(this.mData.dataForm.thong_tin.so_node)
              : null,
            so_doi: this.mData.dataForm.thong_tin.so_doi
              ? Number(this.mData.dataForm.thong_tin.so_doi)
              : null,
          });
      }

      // nếu trạng thái bản in là dang_san_xuat thì chỉ cho cập nhật phần liên hệ gửi đơn hàng
      if (this.trangThaiBanIn === "dang_san_xuat") {
        delete ban_in_object["cau_hinh"];
        ban_in_object.lien_he = {
          ho_ten: this.mData.dataForm.lien_he.ho_ten,
          dien_thoai: this.mData.dataForm.lien_he.dien_thoai,
          dia_chi: this.mData.dataForm.lien_he.dia_chi,
        };
        ban_in_object.trang_thai = this.mData.dataForm.trang_thai;

        if (this.SystemAdmin || this.InGiaPhaDesigner) {
          ban_in_object.ban_mem = {
            anh_dai_dien_id: this.mData.dataForm.ban_mem.anh_dai_dien_id,
            ban_in_id: this.mData.dataForm.ban_mem.ban_in_id,
            file_thiet_ke_id: this.mData.dataForm.ban_mem.file_thiet_ke_id,
            file_watermark_id: this.mData.dataForm.ban_mem.file_watermark_id,
          };
        }
        this.fn_updateBanIn(ban_in_object);
      } else {
        if (
          this.SystemAdmin ||
          this.SalesManagerOrInGiaPhaSales ||
          this.CustomerCareUser
        ) {
          ban_in_object.lien_he = {
            ho_ten: this.mData.dataForm.lien_he.ho_ten,
            dien_thoai: this.mData.dataForm.lien_he.dien_thoai,
            dia_chi: this.mData.dataForm.lien_he.dia_chi,
          };
          ban_in_object.trang_thai = this.mData.dataForm.trang_thai;
          ban_in_object.cau_hinh = {
            ten_pha_do: this.mData.dataForm.cau_hinh.ten_pha_do,
            ten_toc: this.mData.dataForm.cau_hinh.ten_toc,
            dia_chi: this.mData.dataForm.cau_hinh.dia_chi,
            in_dau_re: this.mData.dataForm.cau_hinh.in_dau_re,
            in_ngay_sinh: this.mData.dataForm.cau_hinh.in_ngay_sinh,
            in_ngay_gio: this.mData.dataForm.cau_hinh.in_ngay_gio,
            theme: this.mData.dataForm.cau_hinh.theme,
            node_an_ids: this.listNodeHide.map((node) => node.id),
            node_goc_id: this.mData.dataForm.cau_hinh.node_goc_id,
          };
        }
        if (this.SystemAdmin || this.InGiaPhaDesigner) {
          ban_in_object.ban_mem = {
            anh_dai_dien_id: this.mData.dataForm.ban_mem.anh_dai_dien_id,
            ban_in_id: this.mData.dataForm.ban_mem.ban_in_id,
            file_thiet_ke_id: this.mData.dataForm.ban_mem.file_thiet_ke_id,
            file_watermark_id: this.mData.dataForm.ban_mem.file_watermark_id,
          };
        }
        if (this.SystemAdmin || this.SalesManagerOrInGiaPhaSales) {
          ban_in_object.don_hang = {
            da_chot_don: this.mData.dataForm.don_hang.da_chot_don,
          };
        }

        this.fn_updateBanIn(ban_in_object);
      }
    },

    async fn_updateBanIn(objectBanIn) {
      try {
        const response = await mushroom.ban_in.partialUpdateAsync(objectBanIn);
        if (response.result === this.$router.currentRoute.params.id) {
          window.toastr.success("Cập nhật Bản in thành công");
          MethodService.stopLadda();
          this.$router.go(-1);
          eventBus.$emit("doiTrangThaiBanIn");
        } else window.toastr.warning("Dữ liệu Bản in không thay đổi");
      } catch (e) {
        if (e.detail) {
          window.toastr.warning(e.detail);
        } else MethodService.showError(e.code);
      } finally {
        MethodService.stopLadda();
      }
    },

    fn_changeTrangThaiBanIn(event) {
      this.mData.dataForm.trang_thai = event;
    },
    renderTrangThaiBanIn(trangThai) {
      if (!trangThai) return "";
      if (trangThai === "gui_yeu_cau") return "Gửi yêu cầu";
      if (trangThai === "dang_tu_van") return "Đang tư vấn";
      if (trangThai === "dang_san_xuat") return "Đang sản xuất";
      if (trangThai === "dang_giao_hang") return "Đang giao hàng";
      if (trangThai === "hoan_thanh") return "Hoàn thành";
      if (trangThai === "huy") return "Hủy";
    },
    // lấy danh sách dòng họ để thêm mới bản in
    async fn_getAllDongHo() {
      try {
        const response = await mushroom.dong_ho.listAsync({ limit: 999 });
        if (response.result) {
          this.listDongHo = [];
          response.result.forEach(async (item) => {
            item.dia_chi_full = "";
            let diachi = item.dia_chi.dia_chi;
            let responseTinh = "";
            let responseHuyen = "";
            let responseXa = "";
            if (item.dia_chi.xa_id) {
              responseXa = await mushroom.commune.findByIdAsync({
                id: item.dia_chi.xa_id,
              });
              diachi =
                diachi +
                ", " +
                responseXa.result.type +
                " " +
                responseXa.result.name;
            }
            if (item.dia_chi.huyen_id) {
              responseHuyen = await mushroom.district.findByIdAsync({
                id: item.dia_chi.huyen_id,
              });
              diachi =
                diachi +
                ", " +
                responseHuyen.result.type +
                " " +
                responseHuyen.result.name;
            }
            if (item.dia_chi.tinh_id) {
              responseTinh = await mushroom.province.findByIdAsync({
                id: item.dia_chi.tinh_id,
              });
              diachi =
                diachi +
                ", " +
                responseTinh.result.type +
                " " +
                responseTinh.result.name;
            }
            item.dia_chi_full = "Dòng họ " + item.ten + ", " + diachi;
            this.listDongHo.push({
              value: item.id,
              label: item.dia_chi_full,
            });
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // lấy dòng họ id
    fn_getIdDongHo(event) {
      this.dongHoId = event;
      this.showChonNguoiDung = true;
      this.listNguoiTrongHo = [];
      this.fn_getAllNguoiDungTrongHo();
    },

    async fn_getAllNguoiDungTrongHo() {
      try {
        const response = await mushroom.node_gia_pha.listAsync({
          fields: "id,nguoi_dung_id,ten,nguoi_tao_id",
          filters: ["dong_ho_id=" + this.dongHoId],
          limit: 999,
        });
        if (response.result) {
          response.result.forEach((item) => {
            this.listNguoiTrongHo.push({
              value: item.nguoi_dung_id + "/" + item.id,
              label: item.ten.ho_ten,
            });
          });
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async fn_getIdNguoiDung(event) {
      let arr = event.split("/");
      this.nguoiDungID = arr[0];
      this.nodeID = arr[1];

      // lấy user_id theo nguoi_dung_id(nguoiDungId)
      try {
        const response = await mushroom.nguoi_dung.listAsync({
          fields: "user_id",
          filters: ["id=" + this.nguoiDungID],
        });
        if (!response.result[0].user_id || response.result[0].user_id === "") {
          window.toastr.warning("Không có trường thông tin user_id");
        }
        this.userID = response.result[0].user_id;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // tải lên ảnh, bản in, file thiết kế
    async fn_upload(type) {
      try {
        let res = await mushroom.$file.uploadAsync({
          file: document.getElementById(type).files[0],
        });
        this.$forceUpdate();
        if (type === "anh_dai_dien") {
          this.mData.dataForm.ban_mem.anh_dai_dien_id = res.result;
          setTimeout(() => {
            this.successAnhDaiDien = true;
          }, 2000);
        }
        if (type === "ban_in") {
          this.mData.dataForm.ban_mem.ban_in_id = res.result;
          setTimeout(() => {
            this.successBanIn = true;
          }, 2000);
        }
        if (type === "file_thiet_ke") {
          this.mData.dataForm.ban_mem.file_thiet_ke_id = res.result;
          setTimeout(() => {
            this.successThietKe = true;
          }, 2000);
        }
        if (type === "file_watermark") {
          this.mData.dataForm.ban_mem.file_watermark_id = res.result;
          setTimeout(() => {
            this.successWatermark = true;
          }, 2000);
        }
      } catch (error) {
        console.error(error);
      }
    },

    // xóa file vừa upload
    async fn_remove(type) {
      if (type == "anh_dai_dien") {
        this.mData.dataForm.ban_mem.anh_dai_dien_id = null;
        this.successAnhDaiDien = false;
      }
      if (type == "ban_in") {
        this.mData.dataForm.ban_mem.ban_in_id = null;
        this.successBanIn = false;
      }
      if (type == "file_thiet_ke") {
        this.mData.dataForm.ban_mem.file_thiet_ke_id = null;
        this.successThietKe = false;
      }
      if (type == "file_watermark") {
        this.mData.dataForm.ban_mem.file_watermark_id = null;
        this.successWatermark = false;
      }
      this.$forceUpdate();
    },

    // reset lại thẻ input khi vừa xóa ảnh/video
    fn_onInputClick(event) {
      event.target.value = "";
    },

    // download file
    fn_download(id) {
      mushroom.$file.download(id);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    // quay lại danh sách bản in
    fn_back() {
      this.$router.go(-1);
    },
    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },

    checkKeyUp() {
      this.mData.dataForm.thong_tin.so_node = undefined;
    },
    changeInput() {
      if (this.mData.dataForm.thong_tin.so_doi === "0") {
        this.mData.dataForm.thong_tin.so_doi = undefined;
      }
      if (this.mData.dataForm.thong_tin.so_node === "0") {
        this.mData.dataForm.thong_tin.so_node = undefined;
      }
      if (this.mData.dataForm.so_luong === "0") {
        this.mData.dataForm.so_luong = undefined;
      }
    },

    changeNodeHide() {
      const nodeHide = this.listNode.find(
        (x) => x.id === this.mData.dataForm.cau_hinh.node_an_ids
      );
      const nodeGocMacDinh = this.listNode.filter(
        (x) => !x.quan_he.doi_truoc_1_ids
      )[0];
      this.nodeTrung = nodeHide;

      if (
        nodeHide.id === this.mData.dataForm.cau_hinh.node_goc_id ||
        ((!this.mData.dataForm.cau_hinh.node_goc_id ||
          this.mData.dataForm.cau_hinh.node_goc_id === "") &&
          nodeHide.id === nodeGocMacDinh.id)
      ) {
        this.dialogThongBao = true;
      } else {
        this.listNodeHide.push(nodeHide);
        this.listNode.forEach((node, index) => {
          if (node.id === nodeHide.id) {
            this.listNode.splice(index, 1);
          }
        });
        this.mData.dataForm.cau_hinh.node_an_ids = [];
      }
    },

    deleteNodeHide(node, index) {
      this.listNodeHide.splice(index, 1);
      this.listNode.push(node);
    },

    getParent(item) {
      if (item.quan_he && item.quan_he.cha_me_1_id) {
        const nodeChaMe = this.listNode.find(
          (x) => x.id === item.quan_he.cha_me_1_id
        );
        if (nodeChaMe && nodeChaMe.ten) {
          return `(Con của ${nodeChaMe.ten.ho_ten})`;
        }
        return "";
      } else {
        if (!item.trong_ho) {
          const nodeVoChong = this.listNode.find(
            (x) => x.id === item.quan_he.danh_sach_vo_chong[0].node_id
          );
          if (nodeVoChong && nodeVoChong.ten) {
            if (item.gioi_tinh === "nam") {
              return `(Chồng của ${nodeVoChong.ten.ho_ten})`;
            } else {
              return `(Vợ của ${nodeVoChong.ten.ho_ten})`;
            }
          }
          return "";
        }
        return "";
      }
      return "";
    },

    async getGiaPha() {
      if (this.mData.dataForm.dong_ho_id) {
        try {
          const response = await mushroom.node_gia_pha.cayGiaPhaAsync({
            body: { dong_ho_id: this.mData.dataForm.dong_ho_id },
            fields:
              "id,ten,dia_chi,khoang_dinh,nguoi_quan_lys,lich_su,lich_su_file_id,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
          });
          if (!response.result) {
            return;
          }
          this.listNode = response.result;
          response.result.forEach((node) => {
            node.full_name = `Đời ${
              (node.quan_he && node.quan_he.doi_truoc_1_ids
                ? node.quan_he.doi_truoc_1_ids.length
                : 0) + 1
            }: ${node.ten ? node.ten.ho_ten : ""} ${this.getParent(node)}`;
          });

          if (
            this.mData.dataForm.cau_hinh.node_an_ids &&
            this.mData.dataForm.cau_hinh.node_an_ids.length > 0
          ) {
            this.listNode = response.result.filter(
              (node) =>
                !this.mData.dataForm.cau_hinh.node_an_ids.includes(node.id)
            );
            this.listNodeHide = response.result.filter((node) =>
              this.mData.dataForm.cau_hinh.node_an_ids.includes(node.id)
            );
          }
          this.mData.dataForm.cau_hinh.node_an_ids = [];
        } catch (error) {
          console.error("Có lỗi: %o", error);
        }
      }
    },

    fn_addNodeHide() {
      const nodeHide = this.listNode.find(
        (x) => x.id === this.mData.dataForm.cau_hinh.node_an_ids
      );
      this.nodeTrung = nodeHide;

      this.listNodeHide.push(nodeHide);
      this.listNode.forEach((node, index) => {
        if (node.id === nodeHide.id) {
          this.listNode.splice(index, 1);
        }
      });
      this.mData.dataForm.cau_hinh.node_an_ids = [];
      this.mData.dataForm.cau_hinh.node_goc_id = "";
      this.dialogThongBao = false;
    },

    fn_cancelNodeHide() {
      this.dialogThongBao = false;
      this.mData.dataForm.cau_hinh.node_an_ids = [];
    },
  },
  async created() {
    // kiểm tra loại roles
    if (
      JSON.parse(localStorage.getItem("currentUser")).roles.includes(
        "InGiaPhaSales"
      ) ||
      JSON.parse(localStorage.getItem("currentUser")).roles.includes(
        "SalesManager"
      )
    ) {
      this.SalesManagerOrInGiaPhaSales = true;
    } else this.SalesManagerOrInGiaPhaSales = false;
    if (
      JSON.parse(localStorage.getItem("currentUser")).roles.includes(
        "CustomerCareUser"
      )
    ) {
      this.CustomerCareUser = true;
    } else this.CustomerCareUser = false;
    if (
      JSON.parse(localStorage.getItem("currentUser")).roles.includes(
        "SystemAdmin"
      )
    ) {
      this.SystemAdmin = true;
    } else this.SystemAdmin = false;
    if (
      JSON.parse(localStorage.getItem("currentUser")).roles.includes(
        "InGiaPhaDesigner"
      )
    ) {
      this.InGiaPhaDesigner = true;
    } else this.InGiaPhaDesigner = false;

    // kiểm tra loại viewMode
    if (this.$router.currentRoute.name == "ThemMoiBanIn") {
      this.mData.viewMode = "create";
      await this.fn_getAllDongHo();
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietBanIn") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
      await this.getGiaPha();
    }
    if (this.$router.currentRoute.name == "CapNhatBanIn") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
      await this.getGiaPha();
    }
  },
};
